import React from 'react';
import { RiDeleteBin6Line } from "react-icons/ri";

const DeleteButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-md bg-red-600 text-main-white px-4 font-medium transition hover:bg-red-500/80 hover:scale-105"
        >
            <RiDeleteBin6Line className="me-2" /> {/* Trash Icon */}
            <span>Delete</span>
            <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]">
                <div className="relative h-full w-8 bg-white/20"></div>
            </div>
        </button>
    );
}

export default DeleteButton;
